import { render, staticRenderFns } from "./NeoparentUnlicensed.vue?vue&type=template&id=457ae6e6&scoped=true"
import script from "./NeoparentUnlicensed.vue?vue&type=script&lang=js"
export * from "./NeoparentUnlicensed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ae6e6",
  null
  
)

export default component.exports